module.exports = __webpack_public_path__ + "img/04f60d1.jpg";